"use client";
import { useState } from "react";
import Image from "next/image";
import engineeringImage from "@/assets/images/ai/enterprise-search/answerTab/Engineering.svg";
import customerSupportImage from "@/assets/images/ai/enterprise-search/answerTab/Customer-Support.svg";
import salesImage from "@/assets/images/ai/enterprise-search/answerTab/Sales.svg";
import peopleImage from "@/assets/images/ai/enterprise-search/answerTab/People.svg";
import itSupportImage from "@/assets/images/ai/enterprise-search/answerTab/IT.svg";
import marketingImage from "@/assets/images/ai/enterprise-search/answerTab/Marketing.svg";

const items = [
    {
        label: "Engineering",
        image: engineeringImage,
    },
    {
        label: "Customer Support",
        image: customerSupportImage,
    },
    {
        label: "Sales",
        image: salesImage,
    },
    {
        label: "People",
        image: peopleImage,
    },
    {
        label: "IT Support",
        image: itSupportImage,
    },
    {
        label: "Marketing",
        image: marketingImage,
    },
];

export default function AnswerTabs() {
    const [activeIndex, setActiveIndex] = useState(0);
    const activeItem = items[activeIndex];
    if (!items.length) return null;
    return (
        <section className="bg-white py-12 xl:py-20">
            <div className="container mx-auto px-4">
                <div className="mb-8 text-center xl:mb-10">
                    <h2 className="text-[24px] lg:text-[32px] mb-2 lg:mb-4 text-center mx-auto max-w-[800px] font-semibold text-[#202020]">
                    Every team. Every question.
                    <span className="bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent"> Answered.</span>
                    </h2>
                    <p className="max-w-[800px] mx-auto text-center text-[#202020]">
                    From engineering to sales, Kroolo Search helps every department find answers instantly.
                    </p>
                </div>
                <div className="mx-auto mb-8 flex flex-wrap justify-center gap-2 lg:mb-10">
                    {items.map((item, index) => {
                        const isActive = index === activeIndex;
                        return (
                            <button
                                key={index}
                                type="button"
                                onClick={() => setActiveIndex(index)}
                                className={`rounded-lg border px-3 py-1.5 text-sm font-normal lg:px-4 lg:py-2 ${isActive
                                    ? "border-[#202020] bg-gradient-to-r from-[#781E8F] to-[#422CBB] bg-clip-text text-transparent"
                                    : "border-[#E0E0EA] bg-white text-[#4A4A4A] hover:border-[#C5C5D8]"
                                    }`}
                            >
                                {item.label}
                            </button>
                        );
                    })}
                </div>
                <div className="relative overflow-hidden ">
                    <Image src={activeItem.image} alt={activeItem.label} width={600} height={400} className="w-full h-full object-contain" />
                </div>
            </div>
        </section>
    );
}
